export default __webpack_public_path__ + "static/media/hide.b51c147e.svg";